import React from "react";
import { Helmet } from "react-helmet";

export const Regras = () => {
  return (
    <div className={"p-2 p-lg-5"}>     
      <Helmet>
        <title>Minha Glambox : Regras do Glamclub</title>
      </Helmet>
    
      <h1 className={"display-1"}>Regras do Glamclub</h1>

      <div className={"gb-contentblock p-5 level-2"}>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam maximus lectus eget ultricies lacinia. Donec non euismod magna. Vivamus nec tempus velit, aliquet vulputate orci. Pellentesque et maximus metus. Sed venenatis sed justo sit amet sollicitudin. In hac habitasse platea dictumst. Donec eget enim urna. Donec congue consequat felis, eget scelerisque risus ultricies vel. Vestibulum sagittis tincidunt urna nec tempus. Etiam pellentesque diam et eros pretium consectetur mollis id lectus. Vestibulum dictum mauris neque. Etiam tempor fringilla metus, et mattis lectus imperdiet id.</p>
      </div>
    </div>
  );
};
